/** A lot's old Lot Biography address: it lives under Warehouse now. */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/inventory/lots/$lotId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/warehouse/lot-biography/$lotId",
      params: { lotId: params.lotId },
      replace: true,
    });
  },
});
